import { render, staticRenderFns } from "./TaskCenterList.vue?vue&type=template&id=52452e84"
import script from "./TaskCenterList.vue?vue&type=script&lang=js"
export * from "./TaskCenterList.vue?vue&type=script&lang=js"
import style0 from "./TaskCenterList.vue?vue&type=style&index=0&id=52452e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports